export default {
  PENDENTE_AVALIACAO: '-1',
  NAO_HABILITADO: '0',
  HABILITADO: '1',
};
